import Box from '@mui/joy/Box';
import Typography from '@mui/joy/Typography';
import OrderTable from "./botListTabs/OrderTable";
import Stats from "./botListTabs/Stats";
import {NavigationTabs} from '../../components/tab/NavigationTabs';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import Breadcrumbs from '@mui/joy/Breadcrumbs';
import Transfer from './botListTabs/Transfer';


export function BotsList() {
    return (
        <Box sx={{display: 'flex', minHeight: '100dvh'}}>
            <Box
                component="main"
                className="MainContent"
                sx={{
                    px: {xs: 2, md: 6},
                    pt: {
                        xs: 'calc(12px + var(--Header-height))',
                        sm: 'calc(12px + var(--Header-height))',
                        md: 3,
                    },
                    pb: {xs: 2, sm: 2, md: 3},
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    minWidth: 0,
                    gap: 1,
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        mb: 1,
                        gap: 1,
                        flexDirection: {xs: 'column', sm: 'row'},
                        alignItems: {xs: 'start', sm: 'center'},
                        flexWrap: 'wrap',
                        justifyContent: 'space-between',
                    }}
                >
                    <Breadcrumbs
                        size="sm"
                        aria-label="breadcrumbs"
                        separator={<ChevronRightRoundedIcon/>}
                        sx={{pl: 0}}
                    >
                        <HomeRoundedIcon/>
                        <Typography color="primary" sx={{fontWeight: 500, fontSize: 12}}>
                            Боты
                        </Typography>
                    </Breadcrumbs>
                </Box>
                <Typography level="h2" component="h1">
                    Боты
                </Typography>
                <NavigationTabs tabs={[
                    {
                        tabSlug: 'list',
                        tabTitle: 'Список',
                        tabContent: <OrderTable />
                    },
                    {
                        tabSlug: 'stats',
                        tabTitle: 'Статистика',
                        tabContent: <Stats />
                    },
                    {
                        tabSlug: 'transfer',
                        tabTitle: 'Трансфер',
                        tabContent: <Transfer />
                    }
                ]} />
            </Box>
        </Box>
    );
}
